import { mount } from '../dom-lifecycle';
import { trackEvent } from './datalayer';

/**
 * Po udanej rejestracji (walidacja formularza + utworzenie konta) wysyła
 * event 'sign_up' do dataLayer. Id pól PII bierzemy z atrybutów data-* na
 * formularzu, żeby zgadzały się z realnymi id pól Symfony.
 */
mount('.registration-form', form => {
    $(form).on('submit-success', () => {
        trackEvent({
            event: 'sign_up',
            user: {
                em: fieldValue(form.dataset.signupEmailField),
                ph: fieldValue(form.dataset.signupPhoneField),
            },
        });
    });
});

function fieldValue(id) {
    if (!id) {
        return '';
    }
    const el = document.getElementById(id);
    return el ? el.value : '';
}
